
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { Debounce, cancelDebounce } from '@/utils/decorators';
import Toast from '@/utils/toast';

const namespace: string = 'search';

@Component<Search>({})
export default class Search extends Vue {
	@Action('searchContent', { namespace }) private searchContent!: (searchString: string | null) => Promise<void>;
	@Getter('getSearchItems', { namespace }) private searchItems!: SearchItem[];

	private searchString: string = '';
	private loading: boolean = false;

	private beforeDestroy(): void {
		cancelDebounce(this.search);
	}

	/**
	 * Search the restaurant content (menus, sections, items)
	 * with string provided after a certain amount of time
	 * to prevent fetching every character typed.
	 *
	 * @return {Promise<void>}
	 */
	@Debounce(500)
	private async search(): Promise<void> {
		this.loading = true;
		await this.searchContent(this.searchString)
			.catch((errorMessage) => {
				Toast.error(this.$t('shared.search_dialog.error_searching', { errorMessage }));
			});
		this.loading = false;
	}

	/**
	 * Close modal and redirect the user to the item's list
	 *
	 * @return {void}
	 */
	private selectSearchItem(item: SearchItem): void {
		this.$emit('close-modal');
		let url = '/menus';
		if (item.type === 'section') {
			url += `/${item.menu_id}/sections`;
		}
		else if (item.type === 'section item') {
			url += `/${item.menu_id}/sections/${item.section_id}/items`;
		}
		else if (item.type === 'menu item') {
			url += `/${item.menu_id}/items`;
		}

		this.$router.push(url).catch(() => {});
	}
}
